var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper both"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({on:{"mouseenter":_vm.triggerOpenYenTip}},on),[_vm._v("fas fa-money-bill")])]}}])},[_c('span',{staticClass:"whitespace-pre"},[_vm._v(_vm._s(Math.floor(_vm.landing / 1000)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }